import "./FancyButtons.css";
import { useEffect, useState } from "react";

export function FancyButton({
  id = "",
  heading,
  subheading,
  icon,
  iconConf,
  onClick,
  primary,
  useHover = false,
  activeButton,
  setActiveButton,
  children,
}) {
  const [hoverClassName, setHoverClassName] = useState("");

  useEffect(() => {
    if (useHover) {
      if (primary && !activeButton) {
        setHoverClassName("FancyButton-hover");
      } else {
        setHoverClassName("");
      }
    }
  }, [useHover, activeButton, primary]);

  return (
    <div
      id={id}
      className={`FancyButton ${hoverClassName}`}
      onClick={onClick}
      onMouseOver={() => {
        if (useHover) {
          if (!primary) {
            setHoverClassName("FancyButton-hover");
            setActiveButton(true);
          }
        }
      }}
      onMouseLeave={() => {
        if (useHover) {
          if (!primary) {
            setActiveButton(false);
          }
        }
      }}
    >
      <div className="FancyButton-icon">{icon}</div>
      <div className="FancyButton-text">
        {heading && <h3>{heading}</h3>}
        {subheading && <span>{subheading}</span>}
        {children}
      </div>
      <div className="FancyButton-icon FancyButton-icon-conf ">{iconConf}</div>
    </div>
  );
}

export function FancyButtons({ children, grid }) {
  const setClassNames = () => {
    let classNames = ["FancyButtons"];
    if (grid) classNames = [...classNames, "FancyButtonsGrid"];
    return classNames.join(" ");
  };
  return <div className={setClassNames()}>{children}</div>;
}
